// Auth API tags
export const AUTH_API_TAGS = {
  GET_ME: 'get-me',
  AUTH: 'auth',
} as const;

// App API tags
export const APP_API_TAGS = {
  PLANS: 'plans',
  JOBS: 'jobs',
  APPLIED_JOBS: 'applied-jobs',
  JOB_DETAILS: 'job-details',
  INDUSTRIES: 'industries',
  OFFER_LETTERS: 'offer-letters',
} as const;

// User roles
export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
} as const;

// API tags & role types
export type TAuthApiTags = (typeof AUTH_API_TAGS)[keyof typeof AUTH_API_TAGS];
export type TAppApiTags = (typeof APP_API_TAGS)[keyof typeof APP_API_TAGS];
export type TUserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];
